module.exports = __webpack_public_path__ + "static/media/feature-cake.2c3bc1e7.jpg";